export const WIN_LOSS_PERCENTAGE = {
  prefix: "",
  value1: 54.528301886792455,
  label1: "Win",
  value2: 45.471698113207545,
  label2: "Loss",
  suffix: "%",
  decimals: 0,
};
